import AppleSigninButton from '@components/applesignin/AppleSigninButton';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SocialButton from './SocialButton';
import LineSigninButton from '@components/account/linesignin/LineSigninButton';
const LoginSocial = (props) => {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: props.singleColumn ? 'col-12' : 'col-12 col-sm-8' },
                React.createElement("p", { className: "primary-xs" },
                    t('account.welcomeback'),
                    " ",
                    React.createElement("b", null, props.loginEmail)),
                React.createElement("p", { className: "primary-xs" }, t('login.continuesocial', { socialName: props.socialUsed }))),
            React.createElement("div", { className: props.singleColumn ? 'col-12 mt-12' : 'col-12 col-sm-4 sm-text-right' },
                React.createElement("button", { onClick: () => props.setLoginStep('email'), className: "link primary-xs" }, t('login.editemail'))),
            React.createElement("div", { className: "col-12 mt-24" },
                isLoading && (React.createElement("div", { className: "loading-wrapper" },
                    React.createElement("img", { src: window.loaderSrc, alt: "loading" }),
                    React.createElement("h4", null, t('appointments.formloading', 'Just a few moments')))),
                React.createElement(React.Fragment, null,
                    props.socialUsed == 'Google' && React.createElement(SocialButton, { social: "google", secondary: true, reloadUrl: location.href, setIsLoading: setIsLoading }),
                    props.socialUsed == 'Facebook' && React.createElement(SocialButton, { social: "facebook", secondary: true, reloadUrl: location.href, setIsLoading: setIsLoading }),
                    props.socialUsed == 'Apple' && React.createElement(AppleSigninButton, { secondary: true, setIsLoading: setIsLoading }),
                    props.socialUsed == 'Line' && React.createElement(LineSigninButton, { secondary: true, reloadUrl: location.href, setIsLoading: setIsLoading }))))));
};
export default LoginSocial;
